import type { HillTargetOut, HillScopeKind, ResolvedHillTarget } from '../../../../types/hill';

/** The one dumb rule (mirrors backend get_resolved_target): persona → spine → trail,
 *  counting only a slot whose entity resolved (title non-null). */
export function resolveHillTarget(
  targets: HillTargetOut[],
  personaId: string | undefined,
  spineRootMessageId: string | undefined,
): ResolvedHillTarget | null {
  const order: Array<[HillScopeKind, string | null]> = [
    ['persona', personaId ?? null],
    ['spine', spineRootMessageId ?? null],
    ['trail', null],
  ];
  for (const [kind, ref] of order) {
    const hit = targets.find(
      (t) => t.scope_kind === kind && (t.scope_ref ?? null) === ref && !!t.title,
    );
    if (hit && hit.title) return { title: hit.title, source: kind };
  }
  return null;
}

/** Nearest is_spine_root ancestor id (a peer_response's spine), or undefined. */
export function nearestSpineRootId(
  msgId: string | undefined,
  byId: Map<string, { parent_ids?: string[]; metadata?: { is_spine_root?: boolean } }>,
): string | undefined {
  let curId = msgId;
  let cur = msgId ? byId.get(msgId) : undefined;
  const seen = new Set<string>();
  while (cur && curId && !seen.has(curId)) {
    if (cur.metadata?.is_spine_root) return curId;
    seen.add(curId);
    curId = cur.parent_ids?.[0];
    cur = curId ? byId.get(curId) : undefined;
  }
  return undefined;
}
